
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.537 9.457H9.366a.7.7 0 100 1.4h1.68A5.6 5.6 0 011.4 7 .7.7 0 100 7a7 7 0 0011.816 5.061V13.3a.7.7 0 001.4 0v-3.15a.7.7 0 00-.679-.693zM9.1 7a2.1 2.1 0 10-4.2 0 2.1 2.1 0 004.2 0zM6.3 7a.7.7 0 111.4 0 .7.7 0 01-1.4 0zM7 0a7 7 0 00-4.816 1.939V.7a.7.7 0 10-1.4 0v3.15a.7.7 0 00.7.7h3.15a.7.7 0 100-1.4h-1.68A5.6 5.6 0 0112.6 7 .7.7 0 1014 7a7.001 7.001 0 00-7-7z"}})])
          )
        }
      }
    